import React from "react";
import ModalCloseIcon from "./Modal/CloseIcon";

const ModalHeaderComponent = ({
  customClass = '',
  title,
  toggleModal,
  centeredTitle = true
}) => {
  return (
    <div className={`modal__header bottom-line ${customClass}`}>
      <div className="d-flex justify-content-between align-items-center fz-14 px-20 pt-30">
        {centeredTitle && (<span />)}
        {title && (
          <div className="modal-title fz-24 pb-0">
            {title}
          </div>
        )}
        <ModalCloseIcon toggleModal={toggleModal} />
      </div>
    </div>
  )
}

export default ModalHeaderComponent;